var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.874 2A.889.889 0 0 0 2 2.9v13.323C2 17.194 2.806 18 3.777 18h13.322a.889.889 0 1 0 0-1.777H3.777V2.901a.888.888 0 0 0-.903-.9zm13.32 3.556a.888.888 0 0 0-.61.27l-2.94 2.938-2.036-1.948a.888.888 0 0 0-1.232.003l-3.552 3.437a.888.888 0 1 0 1.235 1.277l2.938-2.844 2.047 1.959c.35.334.901.328 1.242-.014l3.553-3.553a.888.888 0 0 0-.645-1.525z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.23de55d8a3e4bfe34d5b6db92c474e4d.svg";
export { ForwardRef as ReactComponent };